module.exports = __webpack_public_path__ + "img/content9.cd2efecc.png";